export const claimQueryKey = ['claims'];
export const regionsQueryKey = ['regions'];
export const industriesQueryKey = ['industries'];
export const certificationsQueryKey = ['certifications'];
export const casesQueryKey = ['cases'];
export const regulationQueryKey = ['regulations'];
export const specialConsiderationsQueryKey = ['specialConsiderations'];